import dayjs from 'dayjs';

import type {RegularInvite} from '../../../stores/Invites/types';
import type {IProgramInviteDataModel} from './types';

import {datetimeObjToISOString} from '../../../../../utils/datetime';
import {getFileSrc} from '../../../../../utils/entity/file';

export class RegularInviteModel implements IProgramInviteDataModel {
  constructor(public invite: RegularInvite) {}

  get avatar() {
    return getFileSrc(this.invite.user.avatar, 250).url;
  }

  get courseDates() {
    return '';
  }

  get courseLabel() {
    return '';
  }

  get isInviteByEmail() {
    return Boolean(this.invite.email);
  }

  get label() {
    return dayjs(datetimeObjToISOString(this.invite.created)).format('lll');
  }

  get message() {
    return this.invite.message;
  }

  get name() {
    return this.invite.email || this.invite.user.name;
  }
}
